export default "__VITE_ASSET__pJkbkSXP__"